export default __webpack_public_path__ + "static/media/tickYes.b8c2f903.svg";